import MediaCarousel from './mediaCarousel';
import useMediaQuery from "@material-ui/core/useMediaQuery";
import theme from "../../../theme";
import parsePrices from "../../../../functions/parseSWPrices";
import { useEffect, useState } from "react";

export default function ProductGallery({coverId, media, product}) {
	const isMobile = useMediaQuery(theme.breakpoints.down('md'));
	const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
	const prices = parsePrices(product.calculatedPrices && product.calculatedPrices.length > 0 ? product.calculatedPrices[0] : product.calculatedPrice);
	const [parsedMedia, setParsedMedia] = useState(parseMedia());

	useEffect(() => {
		setParsedMedia(parseMedia());
	}, [media])

	function parseMedia() {
		let fullImages = [];
		let thumbImages = [];

		media.forEach(image => {
			if (
				!image ||
				(image.media.url.indexOf('.mp4') < 0 &&
					(image.media.thumbnails.length === 0 || image.media.metadata === null)) ||
				(image?.media?.translated?.customFields?.display_types?.indexOf('original') < 0 &&
				image?.media?.translated?.customFields?.display_types?.indexOf('carousel') < 0) ||
				image.id === coverId
			) {
				return;
			}

			let fullImage = { alt: product.translated.name, imageType: image.media?.translated?.customFields?.display_types?.indexOf('original') >= 0 ? 'canvas' : 'carousel' };
			let thumbImage = { alt: product.translated.name };

			if (image.media.url.indexOf('.mp4') > 0) {
				fullImage.src = image.media.url;
				fullImage.type = 'video';

				thumbImage.type = 'video';
			}

			image.media.thumbnails.forEach((thumb, index) => {
				if (thumb.width >= 840 || index === 0) {
					fullImage.magnify = {
						src: image.media.url,
						width: image.media.metaData.width,
						height: image.media.metaData.height
					};
					fullImage.width = thumb.width;
					fullImage.height = (image.media.metaData.height / image.media.metaData.width) * thumb.width;
					fullImages.aspectRatio = image.media.metaData.width / image.media.metaData.height;
					fullImage.src = thumb.url;
				}

				if (thumb.width === 120 || index === 0) {
					thumbImage.src = thumb.url;

					if (image.media.metaData.width < image.media.metaData.height) {
						thumbImage.height = thumb.height;
						thumbImage.width = (image.media.metaData.width / image.media.metaData.height) * thumb.width;
					} else if (image.media.metaData.width > image.media.metaData.height) {
						thumbImage.width = thumb.width;
						thumbImage.height = (image.media.metaData.height / image.media.metaData.width) * thumb.width;
					} else {
						thumbImage.width = thumb.width;
						thumbImage.height = thumb.height;
					}
				}
			});

			fullImages.push(fullImage);
			thumbImages.push(thumbImage);
		});

		if(fullImages.length === 0) {
			const cover = product.cover.media;

			fullImages.push({
				alt: product.translated.name,
				src: cover.url,
				width: cover?.metaData?.width,
				height: cover?.metaData?.height
			});

			thumbImages.push({
				alt: product.translated.name,
				src: cover.url,
				width: cover?.metaData?.width,
				height: cover?.metaData?.height
			});
		}

		return {full: fullImages, thumbnails: thumbImages};
	}

	function getFirstImageAspectRatio() {
		let aspectRatio = 1;
		let index = 0;

		if (media[index].media.metaData === null) {
			do {
				index = index + 1;
			} while(media[index].media.metaData === null || index >= media.length);
		}

		if(media.length > 0) {
			aspectRatio = media[index].media.metaData.height / media[index].media.metaData.width;
		}

		return aspectRatio;
	}

	function isOnSale() {
		return prices.isOnSale;
	}

	if(!media || media.length === 0) {
		return null;
	}

	return (
		<MediaCarousel
			product={product}
			media={parsedMedia}
			productNumber={product.productNumber}
			isOnSale={isOnSale()}
			thumbnails={true}
			arrows={!isMobile}
			thumbnailPosition={isDesktop ? 'left' : 'bottom'}
			aspectRatio={getFirstImageAspectRatio()}
			videoProps={{
				controls: false,
				autoPlay: true,
				muted: true,
				loop: true,
				style: {
					display: 'block',
					width: '100%',
				}
			}}/>
	);
}
